import { Button } from '@chakra-ui/react';

const ButtonSolid = ({ onClick, background = 'var(--color-info70)', height, width, children, color = 'white', disabled, ...props }) => (
  <Button
    onClick={onClick}
    bg={props.disabled || props.isDisabled ? 'var(--color-neutral50)' : background}
    height={height}
    width={width}
    _hover={{ background }}
    _active={{ background }}
    color={color}
    disabled={disabled}
    {...props}
  >
    {children}
  </Button>
);

export default ButtonSolid;
